"use strict";
var React = require("react");
var InventoryStore = require("../../stores/InventoryStore");
var InventoryActions = require("../../actions/InventoryActions")
var CompanyStore = require("../../stores/CompanyStore");
var AuthStore = require("../../stores/AuthenticationStore");
var Item = require("./Item.react");
var clone = require("clone");
var _ = require('underscore');
var TreeMenu = require('react-tree-menu/index');
var TreeNode = require('react-tree-menu/index').TreeNode;
var TreeMenuUtils = require('react-tree-menu/index').Utils;
var ReactDOM = require('react-dom');
import { Scrollbars } from 'react-custom-scrollbars';
import DepartmentIcon from '../../../images/icons/department.png';
import TypeIcon from '../../../images/icons/type.png';
import LocationIcon from '../../../images/icons/location.png';
import StatusIcon from '../../../images/icons/status.png';
import MarketStore from '../../stores/MarketStore';
import MarketActions from '../../actions/MarketActions';


var FilterList = React.createClass({
    getInitialState: function(){
        return {
            search_val: '',
            tree: this.props.tree,
            filteredList: this.props.tree
        }
    },
    componentDidMount: function(){
        ReactDOM.findDOMNode(this.refs.filterInput).focus();
    },
    filterList: function(){
      var search_val = ReactDOM.findDOMNode(this.refs.filterInput).value.toLowerCase();
      var filteredList = [];

      if (search_val !== '') {
        function checkFilter(el){
          var str = el.name.toLowerCase();
          if(str.search(search_val) != -1){
            var listObj = _.omit(el, 'children');
            filteredList.push(listObj);
          }

          // Loop through all children
          if(el.children) {
            _.each(el.children, function(childNode, index, list){
              checkFilter(childNode);
            });
          }
        }

        _.each(this.state.tree, function(el, index, list) {
          checkFilter(el);
        });

        this.setState({ search_val: search_val, filteredList: filteredList });
      } else {
        this.setState({ search_val: search_val, filteredList: this.props.tree });
      }

    },
    _handleDynamicTreeNodePropChange: function (propName, node) {
        var newTree = TreeMenuUtils.getNewTreeState(node, this.state.filteredList, propName);
        this.setState({ filteredList: newTree });

        if(propName === "checked"){
            var checkedNodes = [];

            function checkChildren(el){
                //if element is checked we want to add it to our array
                if(el.checked){
                    checkedNodes.push(el.id);
                }
                //loop through all children
                if(el.children) {
                    _.each(el.children, function (childNode, index, list) {
                        checkChildren(childNode);
                    });
                }
            }
            //loop through all top level items
            _.each(newTree, function(el, index, list){
                checkChildren(el);
            });

            this.props.treeCheckChange(this.props.section, checkedNodes);
        }
    },
    render: function() {
      var filteredList = this.state.filteredList;
      return (
        <div className="filter-list-wrapper sub-header-filter">
          <div className="filter-popdown-input-wrapper">
            <input
              type="text"
              placeholder="Leita…"
              ref="filterInput"
              className="filter-popdown-input form-control"
              onKeyUp={this.filterList}
            />
            <div className="scrollbar-popout-wrapper">
              <div className="scrollbar-popout">
                <Scrollbars style={{height: 350 }} className="filter-list">
                  <TreeMenu
                    // identifier="id"
                    // stateful={true}
                    data={filteredList}
                    collapsible={true}
                    expandIconClass="fa glyphicon glyphicon-chevron-right"
                    collapseIconClass="fa glyphicon glyphicon-chevron-down"
                    onTreeNodeCollapseChange={this._handleDynamicTreeNodePropChange.bind(null, "collapsed")}
                    onTreeNodeCheckChange={this._handleDynamicTreeNodePropChange.bind(this, "checked")}
                    // onTreeNodeCheckChange={this.props.treeCheckChange.bind(null, this.props.section)}
                  />
                </Scrollbars>
              </div>
            </div>
          </div>
        </div>
      );
    }

});

module.exports = FilterList;

var EquipmentListFilter = React.createClass({
    mixins: [
        require('react-onclickoutside')
    ],
    getInitialState: function() {
        var CompanyState = CompanyStore.getState();
        var filterData = [];
        if (this.props.isMarket) {
          filterData = MarketStore.getState().filterData;
        } else {
          filterData = InventoryStore.getState().filterData;
        }

        var openFields = {
            departments: false,
            types: false,
            locations: false,
            statuses: false
        }

        return {
            filterData: filterData,
            departments: this.makeTree(CompanyState.departments, filterData.departments),
            types: this.makeTree(CompanyState.types, filterData.types),
            locations: this.makeTree(CompanyState.locations, filterData.locations),
            statuses: this.makeTree(CompanyState.statuses, filterData.statuses),
            showFields: openFields
        };

    },
    handleClickOutside: function(evt) {
        this.collapseAll();
    },
    generateState: function(){
        var CompanyState = CompanyStore.getState();
        var filterData = [];
        if (this.props.isMarket) {
          filterData = MarketStore.getState().filterData;
        } else {
          filterData = InventoryStore.getState().filterData;
        }

        return {
            filterData: filterData,
            departments: this.makeTree(CompanyState.departments, filterData.departments),
            types: this.makeTree(CompanyState.types, filterData.types),
            locations: this.makeTree(CompanyState.locations, filterData.locations),
            statuses: this.makeTree(CompanyState.statuses, filterData.statuses)
        };
    },
    componentDidMount: function() {
        InventoryStore.listen(this.onChange);
        CompanyStore.listen(this.onChange);
        MarketStore.listen(this.onChange);
    },
    componentWillUnmount: function() {
        InventoryStore.unlisten(this.onChange);
        CompanyStore.unlisten(this.onChange);
        MarketStore.unlisten(this.onChange);
    },
    onChange: function() {
        this.setState(this.generateState());
    },
    treeCheckChange(type, node) {
        if (!this.props.isMarket) {
          InventoryActions.clearItems();
        } else {
          // MarketActions.clearItems();
        }

        var data = this.state.filterData;
        data.account = AuthStore.getState().account;
        data.owner = AuthStore.getState().id;

        data[type] = node;

        if (data.query === "" && data.departments.length === 0 && data.types.length === 0 && data.locations.length === 0 && data.statuses.length === 0) {
            // Get all the data
            if (this.props.isMarket) {
              MarketActions.getAllItems();
            } else {
              InventoryActions.getItems();
            }
        } else {
            // Request filtered data
            if (this.props.isMarket) {
              MarketActions.filterEquipment(data);
            } else {
              InventoryActions.filterEquipment(data);
            }
        }
    },
    clearFilter: function() {
        if (this.props.isMarket) {
          MarketActions.clearFilter();
        } else {
          InventoryActions.clearFilter();
        }
    },
    makeTree(data, filterData) {
        var departments = _.indexBy(clone(data), 'id');

        var num_selected_object = _.countBy(departments, function(node) {
            return node.checked ? 'checked': 'unchecked';
        });

        var num_selected = 0;
        if(num_selected_object.checked){
            num_selected = num_selected_object.checked;
        }

        var unflatten = function( array, parent, tree ){



            tree = typeof tree !== 'undefined' ? tree : [];
            parent = typeof parent !== 'undefined' ? parent : { id: null };

            var children = _.filter( array, function(child){

                child.checkbox = true;
                child.checked = filterData.indexOf(child.id) !== -1;
                child.label = child.name;

                //check if parent is in our list, if its not we set parent as null
                if(!departments[child.parent]){
                    child.parent = null;
                }

                return child.parent == parent.id;
            });


            if( !_.isEmpty( children )  ){
                if( parent.id == null ){
                   tree = children;
                }else{
                   parent['children'] = children
                }
                _.each( children, function( child ){ unflatten( array, child ) } );
            }

            return tree;
        }

        var tree = unflatten( data );

        var obj = {
            num_selected: num_selected,
            tree: tree
        }

        return obj;
    },
    collapse: function (section){
        if(this.state.showFields){
            var openFields = {
                departments: false,
                types: false,
                locations: false,
                statuses: false
            }
            var elem = clone(this.state.showFields);
            openFields[section] =  !elem[section];
            this.setState({showFields: openFields});
        }
    },
    collapseAll: function(){
        var openFields = {
            departments: false,
            types: false,
            locations: false,
            statuses: false
        }
        this.setState({showFields: openFields});
    },
    render: function() {
        return (
            <div className="equipment-list-affix" data-offset-top="75" data-offset-bottom="200">
              <div className="equipment-list-filter-inner">
                  <div className="filter-item">
                      <div className="filter-header" onClick={this.collapse.bind(null,'departments')}>
                          <img className="icon department" src={DepartmentIcon} />
                          {(this.state.departments.num_selected > 0) && <div className="filter-count">{this.state.departments.num_selected}</div>}
                      </div>
                      {(this.state.showFields['departments']) &&
                      <FilterList treeCheckChange={this.treeCheckChange} tree={this.state.departments.tree} section={'departments'} collapse={this.collapse}></FilterList>
                      }
                  </div>
                  <div className="filter-item">
                      <div className="filter-header" onClick={this.collapse.bind(null,'types')}>
                          <img className="icon type" src={TypeIcon} />
                          {(this.state.types.num_selected > 0) && <div className="filter-count">{this.state.types.num_selected}</div>}
                      </div>
                      {(this.state.showFields['types']) &&
                      <FilterList treeCheckChange={this.treeCheckChange} tree={this.state.types.tree} section={'types'} collapse={this.collapse}></FilterList>
                      }
                  </div>
                  <div className="filter-item">
                      <div className="filter-header" onClick={this.collapse.bind(null,'locations')}>
                          <img className="icon location" src={LocationIcon} />
                          {(this.state.locations.num_selected > 0) && <div className="filter-count">{this.state.locations.num_selected}</div>}
                      </div>
                      {(this.state.showFields['locations']) &&
                      <FilterList treeCheckChange={this.treeCheckChange} tree={this.state.locations.tree} section={'locations'} collapse={this.collapse}></FilterList>
                      }
                  </div>
                  {!this.props.isMarket &&
                    <div className="filter-item">
                      <div className="filter-header" onClick={this.collapse.bind(null,'statuses')}>
                        <img className="icon status" src={StatusIcon} />
                        {(this.state.statuses.num_selected > 0) && <div className="filter-count">{this.state.statuses.num_selected}</div>}
                      </div>
                      {(this.state.showFields['statuses']) &&
                        <FilterList treeCheckChange={this.treeCheckChange} tree={this.state.statuses.tree} section={'statuses'} collapse={this.collapse}></FilterList>
                      }
                    </div>
                  }
                  <div className="filter-item">
                      <div className="filter-header">
                        <a href="#" onClick={this.clearFilter}>Hreinsa</a>
                      </div>
                  </div>
              </div>
            </div>
        );
    }
});

module.exports = EquipmentListFilter;



// WEBPACK FOOTER //
// ./app/scripts/ui/Inventory/EquipmentListFilter.react.js